import React, { memo, useEffect, useRef, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { isIOS, isMobile } from 'react-device-detect'
import { isEmpty } from 'lodash'
import axios from 'axios'

import { GET_ONBOARDING_PLANS } from '../plans/plans/plans.actions'
import Loading from '../Loading'
import OnboardingContainer from '../../containers/login/OnboardingContainerV2'
import useFetchWithCache from '../../hooks/useFetchWithCache'
import { getGeoModalType } from '../../utils/latamCountries'

export default memo(function OnboardingComponent() {
  const { isAuthenticated, keycloak } = useSelector((state) => state.auth)
  const { isFreePlan } = useSelector((state) => state.subscription)
  const { onboardingPlans, isLoadingOnboardingPlans } = useSelector((state) => state.plans)

  // Tipo de modal de geobloqueo: 'none' | 'latam' | 'world'
  const [geoModalType, setGeoModalType] = useState('none')

  // Get data from geolocation api
  const URL = 'https://api.ipgeolocation.io/v2/ipgeo';
  const LOCAL_KEY = 'isFromChile';
  const { data: geoLocation, loading: loadingGeolocation } = useFetchWithCache(URL, LOCAL_KEY);

  useEffect(() => {
    if (!loadingGeolocation && geoLocation) {
      // Chile → 'none' (sin modal); Latam → 'latam'; España/resto del mundo → 'world'
      setGeoModalType(getGeoModalType(geoLocation.location?.country_code2))
    }
  }, [geoLocation, loadingGeolocation])

  const navigate = useNavigate()
  const dispatch = useDispatch()

  useEffect(() => {
    if (isAuthenticated && !isMobile) {
      navigate('/directing')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated])

  useEffect(() => {
    isEmpty(onboardingPlans)
      && dispatch(GET_ONBOARDING_PLANS())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onboardingPlans])

  // Close geoblock modal
  const handleClose = () => {
    setGeoModalType('none')
  }

  const [epgData, setEpgData] = useState({})
  const [isLoadingEpg, setIsLoadingEpg] = useState(false)
  const hasFetchedEpg = useRef(false)

  useEffect(() => {
    if (isAuthenticated !== false || hasFetchedEpg.current) return

    hasFetchedEpg.current = true
    setIsLoadingEpg(true)

    const fetchData = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_API_EPG_URL, {
          params: {
            idSenal: 1,
            _: Date.now()
          }
        });
        setEpgData(response.data.data.programacionJSON);
      } catch (err) {
        // setError(err);
      } finally {
        setIsLoadingEpg(false);
      }
    };
    fetchData();
  }, [isAuthenticated])

  return (
    isLoadingOnboardingPlans || isLoadingEpg
      ? <Loading />
      : (
        <OnboardingContainer
          isAuthenticated={isAuthenticated}
          isFreePlan={isFreePlan}
          isIOS={isIOS}
          isMobile={isMobile}
          keycloak={keycloak}
          handleClose={handleClose}
          onboardingPlans={onboardingPlans}
          geoModalType={geoModalType}
          epgData={epgData}
          isLoadingEpg={isLoadingEpg}
        />
      )
  )
})
